import _ from 'lodash';
import Vue from 'vue';
import { HTTP, SEARCH } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

const defaultSpeaker = {
  category: 'guest',
  _embedded: {
    header_image: {},
    profile_image: {},
  },
};

export default {
  actions: {
    async [actions.DO_CREATE_SPEAKER]({ commit }, params) {
      const { data } = await HTTP.post('/speakers', params);
      commit(mutations.SET_SPEAKER, data.data.speakers[0]);
      return data;
    },
    async [actions.DO_GET_SPEAKER]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.get(`/speakers/${id}`, { params });
      commit(mutations.SET_SPEAKER, data.data.speakers[0]);
      return data;
    },
    async [actions.DO_SEARCH_SPEAKERS]({ commit }, payload) {
      const { data } = await SEARCH.post('/doxa_speakers/speaker/_search', payload);
      const channels = data.hits.hits.map(h => h._source);
      commit(mutations.SET_SPEAKERS, channels);
      return data;
    },
    async [actions.DO_UPDATE_SPEAKER]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.patch(`/speakers/${id}`, params);
      commit(mutations.SET_SPEAKER, data.data.speakers[0]);
      return data;
    },
  },
  getters: {
    [getters.GET_SPEAKER]: state => state.speaker,
    [getters.GET_SPEAKER_FILTERS]: state => state.filters,
    [getters.GET_SPEAKERS]: state => state.speakers,
  },
  mutations: {
    [mutations.SET_SPEAKER](state, speaker) {
      state.speaker = speaker;
    },
    [mutations.SET_SPEAKER_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.speaker;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_SPEAKER_FILTER_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.filters;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_SPEAKERS](state, speakers) {
      state.speakers = speakers;
    },
    [mutations.UNSET_SPEAKER](state) {
      state.speaker = _.cloneDeep(defaultSpeaker);
    },
  },
  state: {
    filters: {
      sort: {
        field: 'episode_count',
        order: 'desc',
      },
    },
    speaker: _.cloneDeep(defaultSpeaker),
    speakers: [],
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/speaker.js